import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, Phone } from 'lucide-react';
export function Hero() {
  return <div className="relative pt-24 pb-16 md:pt-32 md:pb-24 lg:pt-40 lg:pb-32 overflow-hidden" data-id="element-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-42">
          {/* Left Content */}
          <div className="flex flex-col items-start max-w-2xl mx-auto lg:mx-0 text-center lg:text-left z-10" data-id="element-43">
            <div className="inline-block px-4 py-1.5 mb-6 bg-red-50 border border-red-100 rounded-full" data-id="element-44">
              <span className="text-sm font-bold text-red-700 tracking-wide uppercase" data-id="element-45">
                Now Enrolling New Students
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 tracking-tight leading-[1.1] mb-6" data-id="element-46">
              Build Confidence. <br data-id="element-47" />
              Master Discipline. <br data-id="element-48" />
              <span className="text-red-600" data-id="element-49">Thrive.</span>
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0" data-id="element-50">
              Watson Martial Arts helps children and adults develop focus,
              strength, and character through world-class training.
            </p>

            <ul className="space-y-3 mb-10 text-left mx-auto lg:mx-0" data-id="element-51">
              {['Build Unshakable Confidence', 'Improve Focus & Academic Performance', 'Safe, Structured Environment'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-52">
                  <CheckCircle2 className="w-5 h-5 text-red-600 flex-shrink-0" data-id="element-53" />
                  {item}
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-54">
              <Button size="xl" className="w-full sm:w-auto shadow-red-200" data-id="element-55">
                Book A Free Class
              </Button>
              <Button variant="outline" size="xl" className="w-full sm:w-auto gap-2" data-id="element-56">
                <Phone className="w-5 h-5" data-id="element-57" />
                (555) WATSON-1
              </Button>
            </div>

            <p className="mt-4 text-sm text-gray-500 font-medium" data-id="element-58">
              Limited spots available for this month's intake.
            </p>
          </div>

          {/* Right Visual */}
          <div className="relative lg:h-[600px] w-full flex items-center justify-center" data-id="element-59">
            {/* Abstract Background Shapes */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-gray-100 to-gray-50 rounded-full blur-3xl -z-10" data-id="element-60" />

            {/* Image Placeholder */}
            <div className="relative w-full aspect-[4/5] md:aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl bg-gray-900 group" data-id="element-61">
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent z-10" data-id="element-62" />

              {/* This would be a real image in production */}
              <div className="w-full h-full bg-gray-800 flex items-center justify-center text-gray-400 flex-col gap-4" data-id="element-63">
                <div className="w-20 h-20 rounded-full bg-gray-700 flex items-center justify-center" data-id="element-64">
                  <span className="text-4xl" data-id="element-65">🥋</span>
                </div>
                <span className="font-mono text-sm uppercase tracking-widest" data-id="element-66">
                  [High Energy Training Photo]
                </span>
              </div>

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 right-6 z-20 bg-white/95 backdrop-blur rounded-xl p-4 shadow-lg border border-gray-100 transform transition-transform duration-500 hover:scale-105" data-id="element-67">
                <div className="flex items-center gap-4" data-id="element-68">
                  <div className="bg-red-100 p-3 rounded-full" data-id="element-69">
                    <span className="text-2xl" data-id="element-70">🏆</span>
                  </div>
                  <div data-id="element-71">
                    <p className="font-bold text-gray-900" data-id="element-72">#1 Rated Academy</p>
                    <p className="text-sm text-gray-600" data-id="element-73">
                      Voted Best in City 2024
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}